import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * 路由守卫组件
 * 用于保护需要登录才能访问的路由
 */
const ProtectedRoute = ({ children }) => {
  // 加一层判断 当环境NODE_ENV=development，不进行下面的校验，直接访问
  if (process.env.NODE_ENV === 'development') {
    return children;
  }
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>加载中...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

